import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d8b23c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-relative tw-top-0 tw-left-0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "minimenu-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "minimenu-line tw-my-[8px]" }),
  /*#__PURE__*/_createElementVNode("div", { class: "minimenu-line" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-20 tw-bg-mainbg1 tw-opacity-70"
}
const _hoisted_5 = {
  key: 0,
  class: "sf-menu tw-fixed tw-top-0 tw-z-20 tw-w-[360px] tw-right-[0px] tw-h-full tw-bg-primary tw-text-center tw-text-[2rem]"
}
const _hoisted_6 = { class: "tw-text-mainbg1 tw-pt-[60px] tw-pb-[20px] tw-px-[36px] tw-text-right md:tw-hidden" }
const _hoisted_7 = {
  key: 1,
  class: "tw-bg-mainbg1 tw-text-left tw-text-lg tw-border-solid tw-border-y-4 tw-border-primary tw-py-[16px] tw-font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseX = _resolveComponent("CloseX")!
  const _component_MainMenuItems = _resolveComponent("MainMenuItems")!

  return (_ctx.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mobileVisible = true)),
          class: "tw-pt-[65px] tw-pl-[57%] md:tw-hidden"
        }, _hoisted_3),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.mobileVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (_ctx.mobileVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_CloseX, {
                      size: "38px",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobileVisible = false))
                    })
                  ]),
                  _createVNode(_component_MainMenuItems)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_MainMenuItems)
      ]))
}